export const dataJakarta = [
  {
    city: "central jakarta",
    district: [
      "Cempaka Putih",
      "Gambir",
      "Johar Baru",
      "Kemayoran",
      "Menteng",
      "Sawah Besar",
      "Senen",
      "Tanah Abang",
    ],
  },
  {
    city: "south jakarta",
    district: [
      "Cilandak",
      "Jagakarsa",
      "Kebayoran Baru",
      "Kebayoran Lama",
      "Mampang Prapatan",
      "Pancoran",
      "Pasar Minggu",
      "Pesanggrahan",
      "Setia Budi",
      "Tebet",
    ],
  },
  {
    city: "west jakarta",
    district: [
      "Cengkareng",
      "Grogol",
      "Kalideres",
      "Kebon Jeruk",
      "Kembangan",
      "Palmerah",
      "Taman Sari",
      "Tambora",
    ],
  },
  {
    city: "east jakarta",
    district: [
      "Cakung",
      "Cipayung",
      "Ciracas",
      "Duren Sawir",
      "Jatinegara",
      "Keramat Jati",
      "Makasar",
      "Mataram",
      "Pasar Rebo",
      "Pulo Gadung",
    ],
  },
  {
    city: "thousand islands",
    district: ["Kep. Seribu Selatan", "Kep. Seribu Utara"],
  },
];
